import React from 'react';
import { normalizeClassName } from '../../render/renderUtils';
import './PanelCommons.css'
import { RydUserAccount } from '../../accounts/model';
import { CollapsablePanel } from './CollapsablePanel';
import './UserAccountPanel.css';
import { useCurrentUserAccountStore, useUserSession } from '../../stores/CurrentUserAccountStore';
import { API } from '../../ApiClient';

export function UserAccountInfo({
    account,
    setAccount
}: {
    account: RydUserAccount,
    setAccount: (account: RydUserAccount) => void
}) {

    const [isEditing, setIsEditing] = React.useState(false);
    const [editedAccount, setEditedAccount] = React.useState(account);

    const handleEdit = () => {
        setEditedAccount(account);
        setIsEditing(true);
    };

    const handleCancel = () => {
        setIsEditing(false);
    };

    const handleConfirm = () => {
        setAccount(editedAccount);
        setIsEditing(false);
    };

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        if (name === 'name') {
            setEditedAccount(prev => ({
                ...prev,
                user: { ...prev.user, name: value },
            }));
        } else if (name === 'email') {
            setEditedAccount(prev => ({
                ...prev,
                user: { ...prev.user, email: value },
            }));
        } else if (name === 'balance') {
            setEditedAccount(prev => ({
                ...prev,
                balance: parseFloat(value),
            }));
        } else if (name === 'status') {
            setEditedAccount(prev => ({
                ...prev,
                status: value as 'active' | 'inactive',
            }));
        } else if (name === 'username') {
            setEditedAccount(prev => ({
                ...prev,
                user: { ...prev.user, username: value },
            }));
        }
    };

    return (<div className={normalizeClassName(['interaction-panel'])}>
        <h2>User Account Panel</h2>
        {account.user && (
            <div>
            <div className="ryd-account-dev-note">
                <p style={{ fontSize: '0.8rem', lineHeight: 1.2, color: '#b36b00', margin: '0 0 0.75rem' }}>
                    Rydice is under active development. User account features are experimental and incomplete. Please send feedback or report issues to help us improve.
                </p>
            </div>
            </div>
        )}
        {isEditing ? (
            <div>
                <div>
                    <label>
                        Username:
                        <input
                            name="username"
                            value={editedAccount.user.username}
                            onChange={handleChange}
                        />
                    </label>
                </div>
                <div>
                    <label>
                        Name:
                        <input
                            name="name"
                            value={editedAccount.user.name}
                            onChange={handleChange}
                        />
                    </label>
                </div>
                <div>
                    <label>
                        Email:
                        <input
                            name="email"
                            value={editedAccount.user.email}
                            onChange={handleChange}
                        />
                    </label>
                </div>

                <button onClick={handleConfirm}>Confirm</button>
                <button onClick={handleCancel}>Cancel</button>
            </div>
        ) : (
            <div>
                <p>Username: {account.user.username}</p>
                <p>Name: {account.user.name}</p>

                <button onClick={handleEdit} disabled={true}>Edit</button>
            </div>
        )}
    </div>);
}

export function UserAccountPanel({
    isCollpsed,
    toggleCollapse
}: {
    isCollpsed: boolean,
    toggleCollapse: () => void,
}) {

    const currentUserAccountStore = useCurrentUserAccountStore();

    return (
        <CollapsablePanel
            isCollapsed={isCollpsed}
            toggleCollapse={toggleCollapse}
            extraClasses={['ryd-user-account-panel']}
        >
            {currentUserAccountStore.account &&
                <UserAccountInfo
                    account={currentUserAccountStore.account}
                    setAccount={currentUserAccountStore.setAccount}
                />}
            <RydLogoutButton />
        </CollapsablePanel>
    );
}

function RydLogoutButton() {
    const currentUserAccountStore = useCurrentUserAccountStore();
    const sessionStore  = useUserSession();
    const handleLogout = () => {
        // Handle logout logic here
        if (!sessionStore.accessToken) {
            console.warn('No user account to log out');
            return;
        }
        currentUserAccountStore.clearAccount();
        sessionStore.logout();

        API.logoutUser(sessionStore.accessToken)
            .then(() => {
                console.log('User logged out successfully');
                currentUserAccountStore.clearAccount();
            }
            ).catch((error) => {
                console.error('Logout failed:', error);
            }
            );
    };

    return (
        <button className="ryd-logout-button" onClick={handleLogout}>
            Logout
        </button>
    );
}